import { connect } from "react-redux";

import HomeActions from "datamodel/Home/actions";

import Logo from "./Logo";

export default connect(
  (state) => ({
    showDistribution: state.Home.showDistribution,
  }),
  null,
  (stateProps, dispatchProps, ownProps) => {
    const { dispatch } = dispatchProps;
    return {
      ...stateProps,
      ...ownProps,
      ...dispatchProps,
      updateShowDistribution: (showDistribution) =>
        dispatch(HomeActions.updateShowDistribution(showDistribution)),
    };
  },
)(Logo);
